export default __webpack_public_path__ + "static/media/DSC_7349.08d82f32.jpg";